import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@components/library";
import { changeWallet } from "@actions";
import { useTranslation } from "@helpers/translate";

// Поповнення і виведення лише з реального рахунку: у демо-режимі блокуємо сторінку
// і пропонуємо перемкнутись, реальний баланс тут не показуємо.
export const DemoWarning = () => {
  const { __ } = useTranslation();
  const dispatch = useDispatch();
  const { realWallet } = useSelector((state) => state.wallet);

  const switchToRealWallet = () => {
    if (realWallet?.id) {
      dispatch(changeWallet(realWallet));
    }
  };

  return (
    <div className="tab-warning">
      <header className="tab-warning__header">
        <h1 className="tab-warning__title">{__("common.warning")}</h1>
        <p className="tab-warning__text">{__("wallet.warningDemo")}</p>
      </header>

      <Button
        type="button"
        className="tab-warning__btn"
        color="orange"
        size="middle"
        onClick={switchToRealWallet}
        disabled={!realWallet?.id}
      >
        {__("common.confirm")}
      </Button>
    </div>
  );
};

export default DemoWarning;
